const Ul = (props) => (
  <div {...props} className={`textNode is__list ${props.className ? props.className : ''}`}>
    <ul>{ props.children }</ul>
  </div>
)

export default Ul
